import Vue from 'vue/dist/vue.js'
import axios from 'axios'
import $ from 'jquery'
import {PRODUCT_DETAIL_API, updateMetaTitle} from './consts'
import {initialiseSlickAndZoom, unSlickAndZoom} from '../custom'

export default function() {
  new Vue({
    el: '.js-product-detail',
    name: 'Product Detail',
    data() {
      return {
        product: {},
        currentTab: '',
        loggedInUser: null,
        selectedProductOptions: {}, // the visual layer is not reactive to this data
        originalProductImages: [],
        isShowingOriginal: true,
        productOptionJson: [],
        imageChanged: false,
      };
    },
    async mounted() {

      const productSlug = this.$el.dataset.productSlug;

      if (!productSlug) {
        console.error('Invalid product slug');
        //return;
      }

      let productRaw;
  
      try {
        const response = await axios.get(PRODUCT_DETAIL_API + productSlug);
        productRaw = response.data.data;
      } catch (error) {
        if(error.response.status === 404) {
          // 404 redirect / error handling
          const currentPathname = window.location.pathname;
          const pathParts = currentPathname.split('/').filter(part => part !== '');
          pathParts.pop();
          const modifiedPathname = '/' + pathParts.join('/');
          window.location.href = modifiedPathname;

        }
      }

      // Set options status and type slug
      for (const optionType in productRaw.options) {
        for (const opItem in productRaw.options[optionType].items) {
          productRaw.options[optionType].items[opItem].active = false;
          productRaw.options[optionType].items[opItem].typeSlug = productRaw.options[optionType].slug;
        }
      }

      // When pre-selected options are in URL param
      const originalParams = new URLSearchParams(window.location.search);
      if (originalParams.has('product-options')) {
        let preSelectedOptions = originalParams.get('product-options').split('|');
        preSelectedOptions = preSelectedOptions.map(item => {
          let typeSlugValuePair = item.split(':');
          let slugIdPair = typeSlugValuePair[1].split(',');
          return {
            typeSlug: typeSlugValuePair[0],
            slug: slugIdPair[0],
            id: slugIdPair[1],
          }
        })

        if (Array.isArray(preSelectedOptions)) {
          preSelectedOptions.forEach(item => {
            productRaw.options[item.typeSlug].items[item.slug].active = true;
          })

          let buildUrl = preSelectedOptions.map(item => {
            return item.typeSlug+'='+item.id;
          })

          let urlFinal = `/api/products/product/${productRaw.slug}/options/?${buildUrl.join('&')}`;

          const productOptionRes = await axios.get(urlFinal);

          if (productOptionRes.status === 200) {
            let productOptionJson = productOptionRes.data;
            productOptionJson.forEach(item => {
              productRaw.images = [...item.images, ...productRaw.images];
            })
            this.isShowingOriginal = false;
          }

        }
      }



      this.product = productRaw;
      this.originalProductImages = this.product.images;

      // switch active tab
      if (this.product.features) {
        this.currentTab = 'features';
      } else if (this.product.dimensions) {
        this.currentTab = 'dimensions';
      } else if (this.product.warranty) {
        this.currentTab = 'warranty';
      } else if (this.product.downloads) {
        this.currentTab = 'downloads';
      }

      updateMetaTitle(this.product.name);

      // build breadcrumb
      let crumbs = [];
      if (this.product && this.product.parent_category) {
        crumbs.push({
          name: this.product.parent_category.name,
          slug: this.product.parent_category.slug,
          link: `/products/${this.product.parent_category.slug}`
        })
      }

      if (this.product && this.product.category && this.product.parent_category) {
        crumbs.push({
          name: this.product.category.name,
          slug: this.product.category.slug,
          link: `/products/${this.product.parent_category.slug}/${this.product.category.slug}?limit=9&page=1`
        })
      }

      if (this.product && this.product.category && this.product.parent_category) {
        crumbs.push({
          name: this.product.name,
          link: ''
        })
      }

      document.querySelector('.back-to-results').href = '/products/' + crumbs.map(item => {
        return item.slug;
      }).join('/');

      crumbs.unshift({name: 'Home', link: '/'}, {name: 'Products', link: '/products'});

      document.querySelector('#breadcrumb-inject').outerHTML = crumbs.map(item => {
        return `<a href="${item.link}" class="small-button">${item.name}</a>`;
      }).join('<span>/</span>');

      $('#productid').val(this.product.id);
      $('#productname').val(this.product.name);
      $('.js-productname').text(this.product.name);
      $('#productbrand').val(this.product.brand.name);
      $('#producturl').val(`/products/${this.product.category.parent_slug}/${this.product.category.slug}/${this.product.slug}`);
      $('#productimageurl').val(this.product.images[0]['2x']);

      var domainName = window.location.origin;

      document.querySelector('[name=product_url]').setAttribute('value', domainName + `/products/${this.product.category.parent_slug}/${this.product.category.slug}/${this.product.slug}`);
      document.querySelector('[name=product_name]').setAttribute('value', this.product.name);

      setTimeout(function() {
        initialiseSlickAndZoom();
      }, 1000);

      // logged in user check
      const responseUser = await axios.get('/api/user');
      this.loggedInUser = responseUser.data.data;
      if (this.loggedInUser && (this.loggedInUser.role === 'admin' || this.loggedInUser.role === 'showroom_staff')) {
        document.querySelector('.manual-input').style.display = 'block';
      }
    },
    methods: {
      addProductPopup() {
        $('.add-product-popup-wrapper').show();
        $('#add-project-form .manual-input').show();
        $('#add-project-form .sort-by').show();
        $('#add-project-form button').show();
        $('.add-to-project-success').hide();
      },
      openProductEnquiry() {

        $('.product-enquiry-popup-wrapper').show();

      },
      addLoginPopup() {
        $('.my-project-popup-wrapper').show();
      },
      async productOptionClick(optionItem) {
        // Toggle active
        for (const prodOpItem in this.product.options[optionItem.typeSlug].items) {
          let currentItem = this.product.options[optionItem.typeSlug].items[prodOpItem];
          if (optionItem === currentItem) {
            currentItem.active = !optionItem.active;

            if (currentItem.active) {
              this.selectedProductOptions[currentItem.typeSlug] = {
                type: currentItem.type,
                typeSlug: currentItem.typeSlug,
                slug: currentItem.slug,
                id: currentItem.id,
                name: currentItem.name,
              };
            } else {
              Vue.delete(this.selectedProductOptions, currentItem.typeSlug);
            }

          } else {
            currentItem.active = false;
          }
        }

        // Update product gallery
        // /api/products/product/zero-wall-hung-vanity/options/?vanity-finish=609&vanity-top-finish=856
        let selectedOptions = [];

        // since there's no Vuex so use window object as a bridge for adding product to project
        window.oakleys.selectedProductOptions = [];

        let productOptionTextStringBits = [];
        for (const selectedProductOptionsKey in this.selectedProductOptions) {
          const item = this.selectedProductOptions[selectedProductOptionsKey];
          productOptionTextStringBits.push(item.name);
          selectedOptions.push(item.typeSlug+'='+item.id);
          window.oakleys.selectedProductOptions.push({
            typeSlug: item.typeSlug,
            slug: item.slug,
            id: item.id,
            name: item.name
          });
        }

        // Compile a text string for My Project
        let productOptionTextString = productOptionTextStringBits.join(', ');
        $('#productoption').attr('value', productOptionTextString);
        $('#productoptionenquiry').attr('value', productOptionTextString);

        //let productOptionJson;
        let productOptionJsonData;

        if (selectedOptions.length === 0) {
          if (this.isShowingOriginal === true) {
            return;
          }
          this.productOptionJson = [{images: this.originalProductImages}];
          this.isShowingOriginal = true;
          this.imageChanged = true;
        } else {
          let urlFinal = `/api/products/product/${this.product.slug}/options/?${selectedOptions.join('&')}`;

          const productOptionRes = await axios.get(urlFinal);
          productOptionJsonData = productOptionRes.data;

  
          if(!productOptionJsonData || productOptionJsonData.length === 0) {
            
            this.imageChanged = false;

          } else {
            this.productOptionJson = [...productOptionJsonData, {images: this.originalProductImages}];
            this.isShowingOriginal = false;
            this.imageChanged = true;
          }

        }

        if(this.imageChanged) {

          this.product.images = [];
          // reactive vue doesn't work. change to dom operations.
          await unSlickAndZoom();
          this.productOptionJson.forEach((item, index) => {
            item.images.forEach(optionImageItem => {
              document.querySelector('.product-gallery').innerHTML += `
                  <img src="${optionImageItem['large']}" data-slide="${index+1}" alt="${item.name}" class="image-zoom product-gallery-slide"/>`;
              document.querySelector('.product-sub-gallery').innerHTML += `
                  <div><img src="${optionImageItem['large']}" data-slide="${index+1}" alt="${item.name}"/></div>`;
            })
          });
          setTimeout(() => {
            initialiseSlickAndZoom();
          }, 500);

        }

      }
    }
  });
}
